// import React, { useEffect, useState, memo } from 'react';
// import { TbBulb } from 'react-icons/tb';
// import { Capitalize } from './../../functions/commonFunctions';
// import {
//   getDescriptiveSummary,
//   getAlertSummary
// } from '../../services/summaryService';
// import ModalBox from '../../components/modal';
// import parse from 'html-react-parser';
// import { BsChatSquareDots } from 'react-icons/bs';
// import { HiOutlineArrowNarrowRight } from 'react-icons/hi';
// import { Triangle } from 'react-loader-spinner';

// const BusinessNarratives = (props) => {
//   const [dimsummary, setDimensionSummary] = useState([]);
//   const [loader, setLoader] = useState(true);
//   const [loadermessage, setLoaderMessage] = useState('');

//   const dataset_dict = {
//     "Market share Performance": `
//       Drug A market share has increased by 12.57% to reach 40.14%. Market share across regions increased at West (95.28%), Central (6.64%), East (4.91%) and decreased at South (-37.38%).

//       At an account level, market share increased by 27.66% with the biggest contributor being THE GROUP, INC where competitor market share decreased by 60.0% on average over last 4 Months.

//       At a region level, drug discontinuation count has increased by 77.78% from average of last 4 months due to patients onboarding to Caremark in East region specifically in Western PA district increased by 200.0% compared to average of last 4 months.
//     `,
//     "Promotional Performance": `
//       At an overall level, total SEM clicks decreased by -0.87% with Top 3 contributing districts as Atlanta, South Atlantic and Great Lakes East. Total calls increased by 2.54% with Top 3 contributing districts as Atlanta, Great Lakes East and New Orleans. Total speaker program attended increased by 61.11% with Top 3 contributing districts as Great Lakes East, Texas South and Northwest.

//       At a region level, total SEM clicks increased in East (23.52%), Central (22.85%), South (2.94%) and decreased at West (-42.46%).total calls increased at East (26.47%), Central (14.28%), South (9.52%) and decreased at West (-26.41%). total speaker program attended increased at West (75.0%), Central (66.66%), East (66.66%) and remained neutral at South (0.0%).

//       At an account level, total SEM clicks increased significantly compared to the average of last 4 months because there was an uptick in SEM clicks for ADVANCED AND COSMETIC SURGERY HUNTERS CREEK account in South region of Florida district. total calls rose significantly compared to the average of last 4 months with the biggest contributor being ALLERGY ASTHMA AND SINUS CENTER PC account in Central region of South Atlantic district.
//     `
//     // Add more entries as needed
//   };

//   useEffect(() => {
//     async function getData() {
//       try {
//         setLoader(true);
//         // enable loader messages
//         const messages = [
//           'Fetching Persona details',
//           'Identifying preferred metrics',
//           'Sending preference to Gen AI',
//           'Fetching key insights',
//           'Summarizing insights',
//           'Finalising results',
//           'Please wait few more seconds'
//         ];
//         let count = 0;
//         setLoaderMessage(messages[count]);
//         const interval = setInterval(function message() {
//           count += 1;
//           setLoaderMessage(messages[count]);
//           if (count === messages.length - 1) clearInterval(interval);
//         }, 3000);
//         // check for data in local storage
//         if (!sessionStorage.getItem('x_exec_summary')) {
//           const { data: descriptive_summary } = await getDescriptiveSummary(
//             props.user.user_uuid || ''
//           );
//           const { data: alert_summary } = await getAlertSummary(
//             props.user.user_uuid || ''
//           );
//           if (alert_summary.length > 0) {
//             descriptive_summary.forEach((x, i) => {
//               alert_summary.forEach((y, j) => {
//                 if (x.level === y.level) {
//                   if (j === 0)
//                     descriptive_summary[i].summary += '<br/><br/>' + y.summary;
//                   else descriptive_summary[i].summary += y.summary;
//                 }
//               });
//             });
//           }
//           sessionStorage.setItem(
//             'x_exec_summary',
//             JSON.stringify(descriptive_summary)
//           );
//           setDimensionSummary(descriptive_summary);
//         }
//         // use local storage data
//         else {
//           const descriptive_summary = JSON.parse(
//             sessionStorage.getItem('x_exec_summary')
//           );
//           setDimensionSummary(descriptive_summary);
//         }
//         setLoader(false);
//       } catch (err) {
//         setLoader(false);
//         console.log(err);
//       }
//     }
//     getData();
//   }, [props.user.user_uuid]);

//   const SeeMore = (
//     <span className='ms-2'>
//       See more <HiOutlineArrowNarrowRight />
//     </span>
//   );

//   return (
//     <div className='narratives mt-4 place-container'>
//       <h5 className='mb-4 title'>
//         <BsChatSquareDots />
//         Business Narrative
//       </h5>
//       {/* KEY METRICS PERFORMAMCE */}
//       {/* <div className='row m-0'>
//         <div className='col-xs-12 col-md-12 col-lg-12'>
//           {!loader &&
//             kpisummary.length > 0 &&
//             kpisummary.map((x, i) => {
//               const text_length = 300;
//               const text = x.summary.length > text_length ? true : false;
//               return (
//                 <div className='x-card-kpi' key={i}>
//                   <div className='narrative-heading'>
//                     <TbBulb /> Key Metrics Performance
//                   </div>
//                   <div>
//                     {text ? x.summary.substring(0, text_length - 1) : x.summary}
//                     <span className='see-more'>{text ? SeeMore : ''}</span>
//                   </div>
//                 </div>
//               );
//             })}
//           {loader && <div className='loader mb-3'>{PlaceHolder()}</div>}
//         </div>
//       </div> */}
//       {/* LEVEL PERFORMAMCE */}
//       <div className='row m-0'>
//         {!loader &&
//           dimsummary.length > 0 &&
//           dimsummary.map((x) => {
//             const cardlength = 6;
//             const text_length = 380;
//             const text = x.summary.length > text_length ? true : false;
//             const title = Capitalize(x.level) + ' Performance';
//             const content = text
//               ? x.summary.substring(0, text_length - 1)
//               : x.summary;
//             const index = x.date + x.level.replace(' | ', '');
//             return (
//               <div
//                 className={`col-xs-12 col-md-${cardlength} col-lg-${cardlength} mb-3`}
//                 key={index}
//               >
//                 <div className='x-card'>
//                   <div className='narrative-heading'>
//                     <TbBulb /> <span className='flex-fill'>{title}</span>
//                   </div>
//                   <div className='summary-content'>
//                     {content}
//                     <span
//                       className='see-more'
//                       data-bs-toggle='modal'
//                       data-bs-target={'#see-more' + index}
//                     >
//                       {text ? SeeMore : ''}
//                     </span>
//                   </div>
//                   <ModalBox
//                     id={'see-more' + index}
//                     icon={<TbBulb />}
//                     header={title}
//                     content={
//                       <div className='d-flex popup'>
//                         <div>{parse(x.summary.replace(/\n/g, '<br/>'))}</div>
//                       </div>
//                     }
//                   />
//                 </div>
//               </div>
//             );
//           })}
//         {loader && (
//           <div className='loader'>
//             <Triangle
//               height='80'
//               width='80'
//               ariaLabel='triangle-loading'
//               wrapperStyle={{}}
//               wrapperClassName=''
//               visible={true}
//             />
//             <span>{loadermessage}</span>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default memo(BusinessNarratives);
import React, { useEffect, useState, memo } from 'react';
import { TbBulb } from 'react-icons/tb';
import parse from 'html-react-parser';
import { BsChatSquareDots } from 'react-icons/bs';
import { HiOutlineArrowNarrowRight } from 'react-icons/hi';

const BusinessNarratives = (props) => {
  const [loader, setLoader] = useState(true);
  const [expandedEntries, setExpandedEntries] = useState({});

  const dataset_dict = {
    'Market share Performance': {
      'Drug A market share':
        'Drug A market share has increased by 12.57% over the past 5 months to reach 40.14%. Market share contribution within regions are as follows West (50.94%), Central (41.73%), East (41.05%), South (22.89%).',
      'Region level':
        'At the region level, the Central area saw a 15.79% increase in patients discontinuing the drug, attributed to a rise in drug discontinuation observed in the KALAMAZOO account within the Great Lakes District.',
      'Account level':
        'At an account level, the market share for our product increased by 26.32% for the account SKIN CANCER AND INSTITUTE and decreased by 40.85% for the account THE ALLERGY CENTER AT SACENT in the Pacific North district of West region.'
    },
    'Promotional Performance': {
      'Overall level':
        ' At an overall level, total calls increased by 2.54% with Top 3 contributing districts as Atlanta, Great Lakes East and New Orleans. Total marketing emails opened decreased  (-9.78%) with Top 3 contributing districts as Atlanta, Great Lakes East and Florida. Total webinar attended increased by 12.49% with Top 3 contributing districts as Atlanta, Northeast and New Jersey.',
      'Region level':
        ' At a region level, total calls increased for East (26.47%), Central (14.28%), South (9.52%) and decreased for West (-26.41%). Total marketing emails opened increased in Central (3.7%), decreased at South (-37.5%), East (-14.81%) and remained neutral at West (0.0%). Total Rep triggerd emails opened decreased at West (-35.71%),  South (-10.71%), East (-10.52%) and increased at Central (25.64%).',
      'Account level':
        " At an account level,  33.33% increase in total calls from the average of last 4 months has attributed to an increase of 2.23%  in prescription growth for the account - U OF M  ALLERGY SPECIALTY CLINIC AND FOOD ALLERGY CLINIC AT DOMINO'S FARMS.  An increase of 33.33% in total marketing emails clicked from average of last 4 months for account ALONSO in district - Florida has resulted in 0.61% increase in total marketing emails clicked at the overall level."
    }
  };

  useEffect(() => {
    // Simulate loading for 3 seconds
    const timeout = setTimeout(() => {
      setLoader(false);
    }, 3000);

    return () => clearTimeout(timeout);
  }, []);

  const SeeMore = (
    <span className='ms-2'>
      See more <HiOutlineArrowNarrowRight />
    </span>
  );

  const handleSeeMoreClick = (category, key) => {
    setExpandedEntries({
      ...expandedEntries,
      [category]: {
        ...expandedEntries[category],
        [key]: true
      }
    });
  };

  return (
    <div className='narratives mt-4 place-container'>
      <h5 className='mb-4 title'>
        <BsChatSquareDots />
        Business Narrative
      </h5>
      <div className='row m-0'>
        {!loader &&
          Object.entries(dataset_dict).map(([category, entries]) => (
            <div className='col-md-6 mb-3' key={category}>
              <div className='x-card'>
                <div className='narrative-heading'>
                  <TbBulb /> {category}
                </div>
                <div className='summary-content'>
                  {Object.entries(entries).map(([key, content]) => (
                    <div key={key}>
                      <strong>{key}:</strong>
                      {expandedEntries[category]?.[key] ? (
                        parse(content)
                      ) : (
                        <span>
                          {content.length > 180
                            ? content.substring(0, 180) + '... '
                            : content}
                          {content.length > 180 && (
                            <span
                              className='see-more'
                              style={{ cursor: 'pointer', fontSize: 12 }}
                              onClick={() => handleSeeMoreClick(category, key)}
                            >
                              {SeeMore}
                            </span>
                          )}
                        </span>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        {loader && <div className='loader'>{/* Add loader UI here */}</div>}
      </div>
    </div>
  );
};

export default memo(BusinessNarratives);
